module.exports = __webpack_public_path__ + "static/contact-52f2ef0e7fe5ed13e2cd970a1bde43e5.svg";